import {
	APPLY_CUPOM_SUCCESS,
	APPLY_CUPOM_ERROR,
	REMOVE_CUPOM_SUCCESS,
	REMOVE_CUPOM_ERROR
} from '../../actionType';

import { combineReducers } from 'redux';

const data = (state = {}, { type, payload }) => {
	switch (type) {
		case APPLY_CUPOM_SUCCESS:
			return payload;
		case APPLY_CUPOM_ERROR:
			let returnData = payload;
			if (payload.error === 'Already discount to this order') {
				returnData = payload.cupons[0];
			}
			return returnData;
		case REMOVE_CUPOM_SUCCESS:
			return payload;
		case REMOVE_CUPOM_ERROR:
			let returnDataRemove = { ...state, error: 'Error removing cupom.' };
			if (payload.error === 'Remove error') {
				returnDataRemove = { ...payload, error: undefined };
			}
			return returnDataRemove;
		default:
			return state;
	}
};

export default combineReducers({
	data
});
